
import {forkJoin as observableForkJoin,  BehaviorSubject ,  Observable } from 'rxjs';
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/




import * as _ from 'lodash';

import { AddToPendingList } from './../model/terminal-pending.model';

import { AddToPendingService } from './add-to-pending.service';
import { AppUtilityService } from './../../../core/services/app-utility.service';
import { ConfigService } from '../../../core/services/config.service';
import { DataStoreService } from '../../../core/services/datastore.service';
import { EditModeService } from './../../../core/services/edit-mode.service';
import { HttpStatus } from '../../../core/model/http-status-enum.model';
import { Injectable } from '@angular/core';
import { LmsLoaderService } from './../../../core/services/lms-loader.service';
import { LmsLoggerService } from '../../../core/services/lms-logger.service';
import { LmsTerminalStatusSubmenuService } from './../../../core/services/lms-terminal-status-submenu.service';
import { LocoTransfer } from '../../../core/model/loco-transfer.model';
import { MessageDetails } from './../../../core/model/message-details.model';
import { MessageHandlerService } from '../../../core/services/message-handler.service';
import { Router } from '@angular/router';
import { StaticDataStoreService } from './../../../core/services/static-datastore.service';
import { Tab } from '../../../core/model/tab.model';
import { TabData } from '../../../core/model/tab-data.model';
import { TerminalConfigService } from './terminal-config.service';
import { TerminalHandlingUpdateRequest } from '../../../core/model/terminal-handling-update-request-model';
import { TerminalStatus } from '../../../core/model/terminal-status.model';
import { TrainCancelComplete } from './../../../core/model/train-cancel-complete.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';

/**
 * @export
 * @class TerminalStatusService
 */
@Injectable()
export class TerminalStatusService {
    private RESOURCE_URL = '/terminals/';
    private RESOURCE_LOCO_URL = '/locomotives?opr=INQU';
    private RESOURCE_TRAIN_URL = '/trains?opr=INQU';
    private RESOURCE_TRAIN_OPERATION_URL = '/trains';
    private addToPendingSubscription: any;
    updatePendingStatus = [];
    private configData = this.configService.getConfigData();
    private pendingListData: AddToPendingList;
    terminalConfigMessage;
    loadData: Observable<TerminalStatus>;
    private loadDataBS: BehaviorSubject<TerminalStatus>;
    expandHeaderName = '';
    terminalStatusOpenStateBS: BehaviorSubject<Object>;
    terminalStatusOpenState: Observable<Object>;
    loadServiceStarted = false; // this variable is maintain if already a request is stared then no new request to send at the  time of refersh
    /**
     * Creates an instance of TerminalStatusService.
     * @param {HttpClient} http
     * @param {ConfigService} configService
     * @param {DataStoreService} dataStoreService
     * @param {LmsLoggerService} lmsLoggerService
     * @param {StaticDataStoreService} staticDataStoreService
     * @memberOf TerminalStatusService
     */
    constructor(private http: HttpClient,
        private configService: ConfigService,
        private dataStoreService: DataStoreService,
        private lmsLoggerService: LmsLoggerService,
        private staticDataStoreService: StaticDataStoreService,
        private lmsTerminalStatusSubmenuService: LmsTerminalStatusSubmenuService,
        private router: Router,
        private lmsLoaderService: LmsLoaderService,
        private addToPendingService: AddToPendingService,
        private appUtilityService: AppUtilityService,
        private editModeService: EditModeService,
        private messageHandlerService: MessageHandlerService,
        private terminalConfigService: TerminalConfigService) {

        this.loadDataBS = <BehaviorSubject<TerminalStatus>>new BehaviorSubject({});
        this.loadData = this.loadDataBS.asObservable();
        this.terminalConfigMessage = this.terminalConfigService.terminalConfigData.messages;

        this.addToPendingSubscription = this.addToPendingService.terminalPL$.subscribe(data => {
            this.pendingListData = data;
        });
    }

    resetAll() {
        this.addToPendingService.resetAll();
    }

    /**
     * This loads data of Terminal Status Page
     * @param {Tab} tab
     * @memberOf TerminalStatusService
     */
    load(tab: Tab, fromOtherOperation?: boolean, messageText?: string) {

        let terminalStatus: TerminalStatus;
        let foundInDataStore = false;

        setTimeout(() => {
            if (document.getElementById('autoCompleteTexttopHeader')) {
                const selectBox = <HTMLInputElement>document.getElementById('autoCompleteTexttopHeader');
                if (selectBox) {
                    selectBox.select();
                }
            }
        }, 50);

        if (tab && tab.tabSearchParameter) {
            if (tab.tabSearchParameter.searchText) {
                tab.tabSearchParameter.searchText = tab.tabSearchParameter.searchText.trim();
            } else {
                this.lmsLoaderService.hideLoader();
                return;
            }
            if ('error' === tab.subTypeDetail[tab.subType.toLowerCase()].status) {
                this.lmsLoaderService.hideLoader();
                return;
            }
            if (tab.subTypeDetail[tab.subType.toLowerCase()].status !== 'refresh') {
                const tabData = this.dataStoreService.getValue(tab);
                if (tabData) {
                    terminalStatus = <TerminalStatus>(tabData.data[tab.subType]);
                    foundInDataStore = true;
                    this.loadDataBS.next(terminalStatus);
                    this.lmsLoaderService.hideLoader();
                    this.appUtilityService.updateScreenResize();
                }
            } else {
                foundInDataStore = false;
            }
            if (!foundInDataStore) {
                const locateLocoId = tab.locateLocoId;
                tab.locateLocoId = null;
                if (!this.isMnemonicExist(tab.tabSearchParameter.searchText)) {
                    const lTerminalStatus = <TerminalStatus>({
                        httpStatus: 400,
                        errorMessage: this.configService.getConfigData().messages.invalidTerminal
                    });
                    this.loadDataBS.next(lTerminalStatus);
                    this.lmsLoaderService.hideLoader();
                    this.lmsLoggerService.logError('TerminalStatusService => load()',
                        this.configService.getConfigData().messages.invalidTerminal);
                } else {
                    if (!this.loadServiceStarted) {
                        const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
                        const terminalCommonInfoArr = commonopsPicklist.setOfTerminals;
                        const summary = _.find(terminalCommonInfoArr, {'terminalMnemonic': tab.tabSearchParameter.searchText.trim().toUpperCase() });
                        const oprZone = summary !== undefined ? summary['oprZoneCode'].trim() : '';
                        this.loadServiceStarted = true;
                        this.lmsLoaderService.showLoader();
                        const apiUrl = this.configData.urls.API_URL;
                        const sp = tab.tabSearchParameter;
                        const noThroughTrains = sp.noThroughTrains ? sp.noThroughTrains : false;
                        const spinnerVal = sp.spinnerVal ? sp.spinnerVal : 24;
                        this.lmsLoggerService.logInfo('TerminalStatusService=>load service call starts');
                        const trainHttpUrl = this.http.get(
                            `${apiUrl}${this.RESOURCE_URL}${sp.searchText}${this.RESOURCE_TRAIN_URL}&nt=${noThroughTrains ? 'Y' : 'n'}&d=${spinnerVal}`);

                        const locoHttpUrl = this.http.get(
                            `${apiUrl}${this.RESOURCE_URL}${sp.searchText}${this.RESOURCE_LOCO_URL}&nt=${noThroughTrains ? 'Y' : 'n'}&d=${spinnerVal}&oprtngZoneCode=${oprZone}`);

                        observableForkJoin([trainHttpUrl, locoHttpUrl]).subscribe((finalResponse: any) => {
                            this.lmsLoggerService.logInfo('TerminalStatusService=>load service call ends');
                            let iOData: any;
                            let locoData: any;
                            let ioDataPrioritySuccess = false;
                            let locoDataPrioritySuccess = false;

                            if (finalResponse && finalResponse[0] && finalResponse[0].priorityCode) {
                                const pCode = parseInt(finalResponse[0].priorityCode, 10);
                                if (pCode >= 1 && pCode <= 4) {
                                    ioDataPrioritySuccess = true;
                                }
                                iOData = finalResponse[0];
                            }
                            if (finalResponse && finalResponse[1] && finalResponse[1].priorityCode) {
                                const pCode = parseInt(finalResponse[1].priorityCode, 10);
                                if (pCode >= 1 && pCode <= 4) {
                                    locoDataPrioritySuccess = true;
                                }
                                locoData = finalResponse[1];
                            }

                            if (ioDataPrioritySuccess && locoDataPrioritySuccess) {
                                this.loadServiceStarted = false;
                                const keyOrder = Object.keys(this.lmsTerminalStatusSubmenuService.terminalStatusMapping);
                                const locoMainData = {};
                                let continueLocate = false;
                                if (locateLocoId) {
                                    continueLocate = true;
                                }
                                const keyLength = keyOrder.length;
                                let isLocated;
                                let isLocatedKey;
                                for (let i = 0; i < keyLength; i++) {
                                    locoMainData[keyOrder[i]] = locoData[keyOrder[i]];
                                    const locoMainDataLength = locoMainData[keyOrder[i]].length;
                                    for (let j = 0; j < locoMainDataLength; j++) {
                                        locoMainData[keyOrder[i]][j]['index'] = j;
                                        locoMainData[keyOrder[i]][j]['inPeningList'] = false;
                                        locoMainData[keyOrder[i]][j]['trainLocoMixId'] = locoMainData[keyOrder[i]][j]['locomotiveIdentifier'] + '-' + keyOrder[i];
                                        if (continueLocate) {
                                            if (this.appUtilityService.UIformatLocomotiveId(locateLocoId) === this.appUtilityService.UIformatLocomotiveId((locoMainData[keyOrder[i]][j]['locomotiveIdentifier']))) {
                                                isLocated = true;
                                                isLocatedKey = keyOrder[i];
                                                continueLocate = false;
                                                locoMainData[keyOrder[i]][j]['isLocated'] = true;
                                            }
                                        }
                                    }
                                }
                                if (locoData &&  locoData.terminalSummary) {
                                    locoMainData['terminalSummary'] = locoData.terminalSummary;
                                }
                                if (locoData &&  locoData.yardLocalStationSummary) {
                                    locoMainData['yardLocalStationSummary'] = locoData.yardLocalStationSummary;
                                }
                                const outBoundTrains = iOData['outBoundTrains'];
                                const outBoundTrainsLength = outBoundTrains.length;

                                const inBoundTrains = iOData['inBoundTrains'];
                                const inBoundTrainsLength = inBoundTrains.length;

                                const lTerminalStatus = <TerminalStatus>({
                                    terminalStatusIO: iOData,
                                    terminalStatusLocos: locoMainData
                                });

                                lTerminalStatus.refreshTime = iOData.refreshTime;
                                lTerminalStatus.tabId = tab.id;
                                lTerminalStatus.isLocated = isLocated;
                                lTerminalStatus.isLocatedKey = isLocatedKey;
                                const tabData = <TabData>({
                                    id: tab.id,
                                    subType: tab.subType
                                });

                                tabData.data = tabData.data ? tabData.data : {};
                                tabData.data[tab.subType] = lTerminalStatus;
                                tab.subTypeDetail.status.message = '';
                                lTerminalStatus.errorMessage = '';
                                this.lmsLoaderService.hideLoader();
                                lTerminalStatus.httpStatus = HttpStatus.OK;
                                this.dataStoreService.putValue(tab, tabData);
                                this.loadDataBS.next(lTerminalStatus);

                                this.addToPendingService.updatePendingListStatus(true);

                                this.lmsLoggerService.logInfo('TerminalStatusService => load()',
                                    `Terminal Status Data Fetch Successfull for ${JSON.stringify(tab)}`);
                                if (fromOtherOperation) {
                                    this.messageHandlerService.handleMessage(<MessageDetails>({
                                        type: this.configData.message.type.client,
                                        level: this.configData.message.level.success,
                                        target: this.configData.message.target.page,
                                        message: messageText
                                    }));
                                    // check if any pending status length exist then
                                    setTimeout(() => {
                                        if (!_.isEmpty(this.updatePendingStatus)) {
                                            this.addToPendingService.updatePendingListData({
                                                pendingList: this.updatePendingStatus
                                            });
                                        }
                                    }, 100);
                                }
                            } else {
                                this.loadServiceStarted = false;
                                const tempMessageText = ioDataPrioritySuccess ? locoData.messageText : iOData.messageText;
                                this.lmsLoaderService.hideLoader();
                                const lTerminalStatus = <TerminalStatus>({
                                    httpStatus: 400,
                                    errorMessage: fromOtherOperation ?
                                        tempMessageText + ', but ' + finalResponse[0].messageText + ' ' + finalResponse[1].messageText
                                        : finalResponse[0].messageText + ' ' + finalResponse[1].messageText
                                });
                                this.loadDataBS.next(lTerminalStatus);
                                this.lmsLoggerService.logError('TerminalStatusService => load()',
                                    tempMessageText);
                            }
                        }, error => {
                            this.loadServiceStarted = false;
                            this.lmsLoaderService.hideLoader();
                            const lTerminalStatus = <TerminalStatus>({
                                httpStatus: error.status,
                                errorMessage: fromOtherOperation ? messageText + ', but an error has occurred while refreshing the page.' : this.appUtilityService.getHttpErroMessage(error, false)
                            });
                            this.loadDataBS.next(lTerminalStatus);
                            this.lmsLoggerService.logError('TerminalStatusService => load()',
                                this.appUtilityService.getHttpErroMessage(error, false));
                        });
                    }
                }
            }

        } else {
            this.lmsLoaderService.hideLoader();
            this.loadDataBS.next(null);
        }
    }


    /**
     * This is service call to http server to make
     * resequenceLocomotives request to this train
     * @param {*} request
     * @param {string} terminalId
     * @returns
     * @memberOf TrainDataService
     */
    resequenceLocomotives(request: any, terminalId: string) {
        const apiUrl = this.configData.urls.API_URL;
        const RESOURCE_URL = '/terminals/';
        let headers = new HttpHeaders();
        const opr = 'RSEQ';
        const win = 'LWTW';

        headers = headers.append('Content-Type', 'application/json');
        const options = { headers: headers };
        this.lmsLoggerService.logInfo('TerminalStatusService=>resequenceLocomotives service call starts');
        return this.http.put<any>(`${apiUrl}${RESOURCE_URL}${terminalId}/locomotives?opr=${opr}&win=${win}`,
            JSON.stringify(request), options).pipe(
              tap(() => this.lmsLoggerService.logInfo('TerminalStatusService=>resequenceLocomotives service call ends'))
            );
    }
    /**
     * This is used to clean the tab Data
     * @param {Tab} tab
     * @memberOf TerminalStatusService
     */
    clean(tab: Tab) {
        this.dataStoreService.removeSubPanel(tab);
    }

    /**
    * @param {string} terminal
    * @param {TerminalHandlingUpdateRequest} terminalHandlingUpdateRequest
    * @param {string} wc
    * @returns {Observable<Response>}
    *
    * @memberOf PopupService
    */
    updateThp(terminalHandlingUpdateRequest: TerminalHandlingUpdateRequest): Observable<Response> {
        const apiUrl = this.configData.urls.API_URL;
        const RESOURCE_URL = '/terminals/';
        let headers = new HttpHeaders();
        const opr = 'UTHP';
        const windowCode = 'LWTW';
        headers = headers.append('Content-Type', 'application/json');
        const options = { headers: headers };
        return this.http.put<any>(`${apiUrl}${RESOURCE_URL}${terminalHandlingUpdateRequest.thpTerminal}/locomotives/thp?opr=${opr}&wc=${windowCode}`,
            JSON.stringify(terminalHandlingUpdateRequest), options).pipe(
              tap(() => this.lmsLoggerService.logInfo('terminalHandlingService => updateThp()', `Terminal Hanlding Plan Updated for ${JSON.stringify(terminalHandlingUpdateRequest)}`))
            );
    }

    /**
     * check for menmonic exist in static datastore.
     * @param {string} value
     * @returns {boolean}
     * @memberOf TerminalStatusService
     */
    isMnemonicExist(value: string): boolean {
        const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
        if (commonopsPicklist) {
            if (value === 'DELETE' || value === 'OFFLN' || value === 'NEW' || value === 'PARKED') {
                return true;
            }
            if (commonopsPicklist.mapOfMnemonis) {
                const data = commonopsPicklist.mapOfMnemonis ? commonopsPicklist.mapOfMnemonis : null;
                for (const key in data) {
                    if (value && data.hasOwnProperty(key) && value.trim().toUpperCase() === data[key].trim().toUpperCase()) {
                        return true;
                    }
                }
            } else {
                return true;
            }
        } else {
            return true;
        }
        return false;
    }

    /**
     * @private
     * @param {any} str
     * @param {any} padString
     * @param {any} max
     * @returns {string}
     *
     * @memberOf TerminalStatusService
     */
    private rightPad(str, padString, max): string {
        str = str.toString();
        return str.length < max ? this.rightPad(str + padString, padString, max) : str;
    }


    /**
     * @param {TrainCancelComplete} trainCancelComplete
     * @param {*} opr
     * @returns {Observable<Response>}
     *
     * @memberOf TerminalStatusService
     */
    cancelCompleteTrain(trainCancelComplete: TrainCancelComplete, opr: any): Observable<Response> {
        const apiUrl = this.configData.urls.API_URL;
        let headers = new HttpHeaders();
        const win = 'LWTW';
        headers = headers.append('Content-Type', 'application/json');
        const options = { headers: headers };
        this.lmsLoggerService.logInfo('TerminalStatusService=>cancelCompleteTrain service call starts');
        return this.http.put<any>(`${apiUrl}${this.RESOURCE_TRAIN_OPERATION_URL}?opr=${opr}&win=${win}`,
            JSON.stringify(trainCancelComplete), options).pipe(
              tap(() => this.lmsLoggerService.logInfo('TerminalStatusService=>cancelCompleteTrain service call ends'))
            );
    }


    /**
     * @param {*} request
     * @param {string} terminalId
     * @param {string} win
     * @returns
     *
     * @memberOf PopupService
     */
    cancelLocomotivePlan(request: any, terminalId: string, win: string) {
        const apiUrl = this.configData.urls.API_URL;
        const RESOURCE_URL = '/terminals/';
        let headers = new HttpHeaders();
        const opr = 'CPLN';

        headers = headers.append('Content-Type', 'application/json');
        const options = { headers: headers };

        return this.http.put(`${apiUrl}${RESOURCE_URL}${terminalId}/thp?opr=${opr}&win=${win}`,
            JSON.stringify(request), options);
    }

    /**
     * @memberOf TerminalStatusService
     */
    cleanBehaviourSubject() {
        this.loadDataBS.next(null);
    }

    /**
     * Service request for bre exception.
     * @param {Array<String>} locoList
     * @param {string} trainId
     * @returns {Observable<Response>}
     * @memberOf TerminalStatusService
     */
    breTransferRequest(locoList: Array<String>, trainId: string): Observable<Response> {
        const apiUrl = this.configData.urls.API_URL;
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        const options = { headers: headers };
        this.lmsLoggerService.logInfo('TerminalStatusService=>breTransferRequest service call starts');
        return this.http.put<any>(`${apiUrl}/trains/${trainId}/breparam?opr=INQU`,
            JSON.stringify(locoList), options).pipe(
              tap(() => this.lmsLoggerService.logInfo('TerminalStatusService=>breTransferRequest service call ends'))
            );
    }


    /**
     * Loco Transfer Service Call
     * @param {Array<LocoTransfer>} locoTransfer
     * @param {string} operation
     * @returns {Observable<Response>}
     * @memberOf TerminalStatusService
     */
    transferLocomotive(locoTransfer: Array<LocoTransfer>, operation: string): Observable<Response> {
        let headers = new HttpHeaders();
        const apiUrl = this.configData.urls.API_URL;
        const windowCode = 'LWTW';
        headers = headers.append('Content-Type', 'application/json');
        const options = { headers: headers };
        this.lmsLoggerService.logInfo('TerminalStatusService=>transferLocomotive service call starts');
        return this.http.put<any>(`${apiUrl}/locomotives?opr=${operation}&wc=${windowCode}`,
            JSON.stringify(locoTransfer), options).pipe(
              tap(() => this.lmsLoggerService.logInfo('TerminalStatusService=>transferLocomotive service call ends'))
            );
    }

    /**
     * @param {any} data
     *
     * @memberOf TerminalStatusService
     */
    setPendingListStatus(data) {
        const pendingList = this.pendingListData['pendingList'];
        const pendingListLength = pendingList.length;

        if (pendingListLength) {
            // we check if any pending action exist then we
            // set up edit mode because this data come through
            // new requests so we need to do manulayy this
            const actionname = pendingListLength.length > 1 ? 'actions' : 'action';

            const editModeStatus = {
                status: true,
                message: `${this.terminalConfigMessage.youHave} ${pendingListLength} ${actionname} ${this.terminalConfigMessage.pendingWithoutSubmit}`
            };
            setTimeout(() => { this.editModeService.setEditMode(editModeStatus); }, 1000);

        }

        for (let i = 0; i < pendingListLength; i++) {
            this.setLocoTrainPendindStatus(true, pendingList[i].action, pendingList[i], data);
        }
    }

    /**
     * @private
     * @param {Boolean} status
     * @param {string} [action]
     * @param {AddToPendingList} [pendingData]
     * @param {TerminalStatus} [loadData]
     *
     * @memberOf TerminalStatusService
     */
    private setLocoTrainPendindStatus(status: Boolean, action?: string, pendingData?: AddToPendingList, loadData?: TerminalStatus) {
        const localPendingData = pendingData;
        const inBoundTrain = loadData.terminalStatusIO.inBoundTrains;
        const inBoundLength = inBoundTrain.length;
        const outBoundTrain = loadData.terminalStatusIO.outBoundTrains;
        const outBoundLength = outBoundTrain.length;
        const terminalList = loadData.terminalStatusLocos;
        const totalTerminalListLocos = [terminalList.onTerminalList,
        terminalList.atServiceCentreList,
        terminalList.onPitList,
        terminalList.inShopList,
        terminalList.inReadyTrackList,
        terminalList.storedAtTerminalList,
        terminalList.yardAndLocalList
        ];

        for (let i = 0; i < inBoundLength; i++) {
            // checking for locos
            for (const loco of inBoundTrain[i].locoDetails) {
                for (let j = 0; j < localPendingData.locos.length; j++) {
                    if (localPendingData.locos[j].trainLocoMixId
                        === loco.trainLocoMixId) {
                        loco.inPendingList = status;
                        loco.checked = status;
                    }
                }
            }

            if (!(action && (action === 'Train' || action === 'Foreign Railroad' || action === 'Terminal'))) {

                // checking for train
                for (let j = 0; j < localPendingData.trains.length; j++) {
                    if (localPendingData.trains[j].trainIdentifier === inBoundTrain[i].trainIdentifier) {
                        inBoundTrain[i].inPendingList = status;
                        inBoundTrain[i].checked = status;
                    }
                }
            }

        }

        for (let i = 0; i < outBoundLength; i++) {
            // checking for locos
            for (const loco of outBoundTrain[i].locoDetails) {
                for (let j = 0; j < localPendingData.locos.length; j++) {
                    if (localPendingData.locos[j].trainLocoMixId ===
                        loco.trainLocoMixId) {
                        loco.inPendingList = status;
                        loco.checked = status;
                    }
                }
            }
            if (!(action && (action === 'Train' || action === 'Foreign Railroad' || action === 'Terminal'))) {
                // checking for train
                for (let j = 0; j < localPendingData.trains.length; j++) {
                    if (localPendingData.trains[j].trainIdentifier === outBoundTrain[i].trainIdentifier) {
                        if (action === 'resequence') {
                            outBoundTrain[i].checked = status;
                        } else {
                            outBoundTrain[i].inPendingList = status;
                            outBoundTrain[i].checked = status;
                        }
                    }
                }
            }
        }

        for (let i = 0; i < totalTerminalListLocos.length; i++) {
            if (!_.isEmpty(totalTerminalListLocos[i])) {
                for (let r = 0; r < totalTerminalListLocos[i].length; r++) {
                    for (let j = 0; j < localPendingData.locos.length; j++) {
                        if (localPendingData.locos[j].trainLocoMixId ===
                            totalTerminalListLocos[i][r].trainLocoMixId) {
                            totalTerminalListLocos[i][r].inPendingList = status;
                            totalTerminalListLocos[i][r].checked = status;
                        }
                    }
                    // if (localPendingData.locos.indexOf(totalTerminalListLocos[i][r]) > -1) {
                    //     totalTerminalListLocos[i][r].inPendingList = status;
                    //     totalTerminalListLocos[i][r].checked = status;
                    // }
                }
            }
        }
        this.addToPendingService.updatePendingListStatus(true);

    }
}
